"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CSS_PREFIX = 'webtreemap-';
var NODE_CSS_CLASS = CSS_PREFIX + 'node';
var DEFAULT_CSS = "\n.webtreemap-node {\n  cursor: pointer;\n  position: absolute;\n  border: solid 1px #666;\n  box-sizing: border-box;\n  overflow: hidden;\n  background: white;\n  transition: left .15s, top .15s, width .15s, height .15s;\n}\n\n.webtreemap-node:hover {\n  background: #ddd;\n}\n\n.webtreemap-caption {\n  font-size: 10px;\n  text-align: center;\n}\n";
function addCSS(parent) {
    var style = document.createElement('style');
    style.innerText = DEFAULT_CSS;
    parent.appendChild(style);
}
function isDOMNode(e) {
    return e.classList.contains(NODE_CSS_CLASS);
}
exports.isDOMNode = isDOMNode;
function getNodeIndex(target) {
    var index = 0;
    var node = target;
    while ((node = node.previousElementSibling)) {
        if (isDOMNode(node))
            index++;
    }
    return index;
}
function getAddress(el) {
    var address = [];
    var n = el;
    while (n && isDOMNode(n)) {
        address.unshift(getNodeIndex(n));
        n = n.parentElement;
    }
    address.shift();
    return address;
}
exports.getAddress = getAddress;
function px(x) {
    return Math.round(x) + 'px';
}
function defaultOptions(options) {
    var opts = {
        padding: options.padding || [14, 3, 3, 3],
        caption: options.caption || (function (node) { return node.id || ''; }),
        showNode: options.showNode ||
            (function (node, width, height) {
                return width > 20 && height >= opts.padding[0];
            }),
        showChildren: options.showChildren ||
            (function (node, width, height) {
                return width > 40 && height > 40;
            }),
    };
    return opts;
}
var TreeMap = (function () {
    function TreeMap(node, options) {
        this.node = node;
        this.options = defaultOptions(options);
    }
    TreeMap.prototype.ensureDOM = function (node) {
        if (node.dom)
            return node.dom;
        var dom = document.createElement('div');
        dom.className = NODE_CSS_CLASS;
        if (this.options.caption) {
            var caption = document.createElement('div');
            caption.className = CSS_PREFIX + 'caption';
            caption.innerText = this.options.caption(node);
            dom.appendChild(caption);
        }
        node.dom = dom;
        return dom;
    };
    TreeMap.prototype.selectSpan = function (children, space, start) {
        var smin = children[start].size;
        var smax = smin;
        var sum = 0;
        var lastScore = 0;
        var end = start;
        for (; end < children.length; end++) {
            var size = children[end].size;
            if (size < smin)
                smin = size;
            if (size > smax)
                smax = size;
            var nextSum = sum + size;
            var score = Math.max(smax * space * space / (nextSum * nextSum), nextSum * nextSum / (smin * space * space));
            if (lastScore && score > lastScore) {
                break;
            }
            lastScore = score;
            sum = nextSum;
        }
        return { end: end, sum: sum };
    };
    TreeMap.prototype.layoutChildren = function (node, level, width, height) {
        var total = node.size;
        var children = node.children;
        if (!children)
            return;
        var x1 = -1, y1 = -1, x2 = width - 1, y2 = height - 1;
        var spacing = 0;
        var padding = this.options.padding;
        y1 += padding[0];
        if (padding[1]) {
            x2 -= padding[1] + 1;
        }
        y2 -= padding[2];
        x1 += padding[3];
        var i = 0;
        if (this.options.showChildren(node, x2 - x1, y2 - y1)) {
            var scale = Math.sqrt(total / ((x2 - x1) * (y2 - y1)));
            var x = x1, y = y1;
            children: for (var start = 0; start < children.length;) {
                x = x1;
                var space = scale * (x2 - x1);
                var _a = this.selectSpan(children, space, start), end = _a.end, sum = _a.sum;
                if (sum / total < 0.1)
                    break;
                var height_1 = sum / space;
                var heightPx = Math.round(height_1 / scale) + 1;
                for (i = start; i < end; i++) {
                    var child = children[i];
                    var size = child.size;
                    var width_1 = size / height_1;
                    var widthPx = Math.round(width_1 / scale) + 1;
                    if (!this.options.showNode(child, widthPx - spacing, heightPx - spacing)) {
                        break children;
                    }
                    var needsAppend = child.dom == null;
                    var dom = this.ensureDOM(child);
                    var style = dom.style;
                    style.left = px(x);
                    style.width = px(widthPx - spacing);
                    style.top = px(y);
                    style.height = px(heightPx - spacing);
                    if (needsAppend) {
                        node.dom.appendChild(dom);
                    }
                    this.layoutChildren(child, level + 1, widthPx, heightPx);
                    x += widthPx - 1;
                }
                y += heightPx - 1;
                start = end;
            }
        }
        for (; i < children.length; i++) {
            if (!children[i].dom)
                break;
            children[i].dom.parentNode.removeChild(children[i].dom);
            children[i].dom = undefined;
        }
    };
    TreeMap.prototype.render = function (container) {
        var _this = this;
        addCSS(container);
        var dom = this.ensureDOM(this.node);
        var width = container.offsetWidth;
        var height = container.offsetHeight;
        dom.onclick = function (e) {
            var node = e.target;
            while (!isDOMNode(node)) {
                node = node.parentElement;
                if (!node)
                    return;
            }
            var address = getAddress(node);
            _this.zoom(address);
        };
        dom.style.width = width + 'px';
        dom.style.height = height + 'px';
        container.appendChild(dom);
        this.layoutChildren(this.node, 0, width, height);
    };
    TreeMap.prototype.zoom = function (address) {
        var node = this.node;
        var _a = this.options.padding, padTop = _a[0], padRight = _a[1], padBottom = _a[2], padLeft = _a[3];
        var width = node.dom.offsetWidth;
        var height = node.dom.offsetHeight;
        for (var _i = 0, address_1 = address; _i < address_1.length; _i++) {
            var index = address_1[_i];
            width -= padLeft + padRight;
            height -= padTop + padBottom;
            if (!node.children)
                throw new Error('bad address');
            for (var _b = 0, _c = node.children; _b < _c.length; _b++) {
                var c = _c[_b];
                if (c.dom)
                    c.dom.style.zIndex = '0';
            }
            node = node.children[index];
            var style = node.dom.style;
            style.zIndex = '1';
            style.left = px(padLeft - 1);
            style.width = px(width);
            style.top = px(padTop - 1);
            style.height = px(height);
        }
        this.layoutChildren(node, 0, width, height);
    };
    return TreeMap;
}());
exports.TreeMap = TreeMap;
function render(container, node, options) {
    new TreeMap(node, options).render(container);
}
exports.render = render;
//# sourceMappingURL=treemap.js.map